import { AUTHENTICATED_EMPLOYEE_JWT } from "../constants";

export const useIsAuthenticatedEmployee = (): boolean => {
  const urlParams = new URLSearchParams(window.location.search);
  const encodedJwt = urlParams.get(AUTHENTICATED_EMPLOYEE_JWT);

  encodedJwt && window.localStorage.setItem(AUTHENTICATED_EMPLOYEE_JWT, encodedJwt);

  const authenticatedEmployee = window.localStorage.getItem(AUTHENTICATED_EMPLOYEE_JWT);

  return Boolean(authenticatedEmployee);
};
